// extracted by mini-css-extract-plugin
export default {"checkbox":"GroupCheckbox_checkbox__LnHjR"};